import { safeLocalStorage } from "../utils/safeLocalStroage.ts";

export function useLocalStorage<T>(key: string, defaultValue: T) {
  const get = (): T => {
    const raw = safeLocalStorage.getItem(key);
    if (!raw) return defaultValue;
    try {
      const value = JSON.parse(raw) as T;
      return value;
    } catch (e) {
      console.error(String(e));
      safeLocalStorage.removeItem(key);
      return defaultValue;
    }
  };

  const set = (value: T) => {
    safeLocalStorage.setItem(key, JSON.stringify(value));
  };

  return { get, set };
}
